import {
  UPDATE_BAZAAR_ACTIVE_STATUS_REQUEST,
  UPDATE_BAZAAR_ACTIVE_STATUS_SUCCESS,
  UPDATE_BAZAAR_ACTIVE_STATUS_FAILURE,
  UPDATE_BAZAAR_ACTIVE_STATUS_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const updateBazaarActiveStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BAZAAR_ACTIVE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case UPDATE_BAZAAR_ACTIVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Bazaar status updated successfully",
      }

    case UPDATE_BAZAAR_ACTIVE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case UPDATE_BAZAAR_ACTIVE_STATUS_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default updateBazaarActiveStatusReducer
